import type { PlanFeature } from '#shared/organizations/planFeatures'

/**
 * Whether the signed-in user's organization has `feature` on its plan (MAR-199), from the
 * `feature_flags` `/api/profile` already carries.
 *
 * THE CLIENT'S HALF OF PLAN GATING (MAR-980). `requireFeature` on the server is the authoritative
 * gate and answers a bare 403; this exists so the client never ASKS for what the plan refuses.
 * Before it, a Light org's `/app` load fired `/api/cases`, `/api/clients` and `/api/runs` and got
 * three 403s, two of them unhandled. Call it before any request to a gated prefix (the table in
 * Notion "Usage Metering & Quota" §10) that can run on a page every plan reaches.
 *
 * It reads the LIVE profile at call time and never snapshots it, so a plan changed by an operator is
 * followed at the next profile read, the same lag the rail and the route guard already accept.
 * Waits for Firebase and for the profile first; a profile that could not be loaded answers `false` —
 * a request made without knowing the plan is the request this exists to prevent, and an app whose
 * profile failed has nothing to show from those endpoints either.
 */
export async function planAllows(feature: PlanFeature): Promise<boolean> {
  const { waitForAuth } = useAuth()
  const { profile, ensure } = useUserProfile()
  await waitForAuth()
  await ensure()
  return profile.value?.feature_flags?.[feature] === true
}
